import { isInView } from './utils';

const scrollCart = {
  cartLine: document.getElementById('addToCartLine'),
  cartBtn: document.querySelector('.jsInView') as HTMLElement | null,

  init() {
    window.addEventListener('DOMContentLoaded', this.setScroll.bind(this));
    window.addEventListener('scroll', this.setScroll.bind(this));
  },

  setScroll() {
    if (this.cartBtn && isInView(this.cartBtn)) {
      this.cartLine?.classList.add('activeClass');
    } else {
      this.cartLine?.classList.remove('activeClass');
    }
  },
};

export default scrollCart;